import '../../Assets/Styles/home.css';
import '../../Assets/Styles/order.css';
import * as config from '../../Config/environment.js';
import React,{useState} from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {useNavigate,useParams } from 'react-router-dom';

import { InputText } from 'primereact/inputtext';
import { InputSwitch } from 'primereact/inputswitch';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import Grid from '@mui/material/Grid';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { OverlayPanel } from 'primereact/overlaypanel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ProgressBar } from 'primereact/progressbar';
import { Skeleton } from 'primereact/skeleton';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Tooltip } from 'primereact/tooltip';
import { Slider } from "primereact/slider";
import { Galleria } from 'primereact/galleria';
import { TabView, TabPanel } from 'primereact/tabview';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog'; // For <ConfirmDialog /> component
import { confirmDialog } from 'primereact/confirmdialog'; // For confirmDialog method

import {Panel} from 'primereact/panel';
import { Message } from 'primereact/message';

import 'moment/locale/pt-br';
// import moment from "moment";
import moment, { lang } from 'moment-business-days';


// Load Actions
import * as AppActions from '../../Store/Actions/App'
import * as OrderActions from '../../Store/Actions/Order'

import AboutUs from '../../Components/layout/AboutUs';
import ContactUs from '../../Components/layout/ContactUs';

import iconResponsibleWarning from '../../Assets/Images/iconResponsibleWarn.svg';
import iconDownload from '../../Assets/Images/iconDownload.svg';
import iconSendEmail from '../../Assets/Images/iconSendEmail.svg';
import iconNewBooking from '../../Assets/Images/iconNewBooking.svg';

// import Timer from '../../Components/Timer'; WEB WORKER FOR BACKGROUND TASK

// Load Componentes 
import AlertView from '../../Components/AlertModal';
import TermsView from '../../Components/TermsModal';

import {
    formatNumberCurrency,
    padronizarDecimal,
    maskCPF,
    validarCPF,
    validarEmail,
    validarTelefone,
    aplicarMascaraDataNascimento,
    maskPhone,
    getAgeCategory
} from '../../Components/Utils';

// Set booking timer
var bookingTimer;

// export default function HomePage() {
const BookingConfirmation = (props) => {
    
// Set var from props
const {
    setDialog,
    dialog,
    currentAgency,
    searchParams,
    exchangeRates,
    selectedProperty,
    setSelectedProperty,
    downloadQuotePdf,
    retrievePersonInfoByDocument,
    createBooking,
    setCurrentBooking,
    currentBooking,
    deleteDirectSearchResult,
    searchResultToken,
    paymentConfirmed
} = props;

const { id } = useParams();

// set bookingdata
const bookingDataTmp = selectedProperty?.bookingData || {};

//console.log('[selectedProperty]--------->]'+JSON.stringify(selectedProperty, null, 2));
//console.log('[cancellationDeadline]--------->]'+JSON.stringify(selectedProperty?.bookingData?.bookingInfo?.cancellationDeadline, null, 2));

const [propertyId, setPropertyId] = useState(null); 

const [creatingBooking, setCreatingBooking] = useState(false); 
const [loadingFiltering, setLoadingFiltering] = useState(false); 
const [loading, setLoading] = useState(true); 
const [saving, setSaving] = useState(false); 

const [contentLoaded, setContentLoaded] = useState(false); 
const [hostingOption, setHostingOptions] = useState(false); 
const [currentStep, setCurrentStep] = useState(1); // 1 continent - 2 country - 3 city  - 4 options

const [contentLoading, setContentLoading] = useState(true); 

const [currentContinent, setCurrentContinent] = useState({}); // id and label
const [currentCountry, setCurrentCountry] = useState({}); // id and label
const [currentCity, setCurrentCity] = useState({}); // id and label

const [breadcrumbArray, setBreadcrumbArray] = useState([]); // id and label
    
const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

const [email, setEmail] = useState('');
const [password, setPassword] = useState('');
const [stillConnected, setStillConnected] = useState(false);
const onStillConnectedChange = (e) => {
    if (e.checked)
        setStillConnected(true);
    else
        setStillConnected(false);
}  // end function
    
// Alert control
const [alert, setAlert] = useState(false); 
const [alertTitle, setAlertTitle] = useState("Informações"); 
const [alertBody, setAlertBody] = useState("Conteúdo dinâmico"); 
const [alertAction, setAlertAction] = useState(""); 

// Expire Dialog control
const [alertExpire, setAlertExpire] = useState(false); 
const [alertTitleExpire, setAlertTitleExpire] = useState("Informações"); 
const [alertBodyExpire, setAlertBodyExpire] = useState("Conteúdo dinâmico"); 
const [alertActionExpire, setAlertActionExpire] = useState("restartSearch"); 

const [currentPlaces, setCurrentPlaces] = useState([]); 		

const [hostsAndRoomsLabel, setHostsAndRoomsLabel] = useState(null); 
const [hostsLabel, setHostsLabel] = useState(null); 
const [roomsLabel, setRoomsLabel] = useState(null); 
const [dateRangeDays, setDateRangeDays] = useState(null); 

const [hostsAndRooms, setHostsAndRooms] = useState(null); 
const [rooms, setRooms] = useState([{ adults: 2, children: [] }]); // Default at least 1 adult
const [selectedRooms, setSelectedRooms] = useState([]); // Default at least 1 adult

const [totalAmountPaidNow, setTotalAmountPaidNow] = useState(0.00); // Default at least 1 adult
const [totalAmount, setTotalAmount] = useState(0.00); // Default at least 1 adult
const [totalCollectedFeeAmount, setTotalCollectedFeeAmount] = useState(null); // Default at least 1 adult
const [currencyCollectedFeeAmount, setCurrencyCollectedFeeAmount] = useState(null); // Default at least 1 adult
const [totalAmountGrouped, setTotalAmountGrouped] = useState(""); // Default at least 1 adult
const [localCollectedFeeItems, setLocalCollectedFeeItems] = useState([]); // Default at least 1 adult

const [roomsButtonDisabled, setRoomsButtonDisabled] = useState(false); // Default at least 1 adult

/* Temporary used to set selected room guests */
const [selectedGuests, setSelectedGuests] = useState({adults:1,children:[]});
const [selectedChildAges, setSelectedChildAges] = useState([]);
const [availableChildAges, setAvailableChildAges] = useState([]);

const [availableChildren, setAvailableChildren] = useState([]);
const [availableAdults, setAvailableAdults] = useState([]);
const [remainingAdults, setRemainingAdults] = useState(0);
const [remainingChildren, setRemainingChildren] = useState([]);

const [imageWithError, setImageWithError] = useState(0);

const [dateRange, setDateRange] = useState([]); 
const [formattedValue, setFormattedValue] = useState('');

const prevDateRangeRef = React.useRef(null); // to save precvious dateRange before change

const [filterByCity, setFilterByCity] = useState(null); 
const [filterByCountry, setFilterByCountry] = useState(null); 

const [resultCard, setResultCard] = useState({});

// Exchange rate USD
const [usdExchangeRate, setUsdExchangeRate] = useState(null);
const [exchangeRateInitials, setExchangeRateInitial] = useState("USD");

// Booking details
const [responsibleDocumentType, setResponsibleDocumentType] = useState(false);
const [responsibleDocument, setResponsibleDocument] = useState("");
const [responsibleName, setResponsibleName] = useState(bookingDataTmp?.bookingVoucherInfo?.responsibleName || "");
const [responsibleBirthDate, setResponsibleBirthDate] = useState(bookingDataTmp?.bookingVoucherInfo?.responsibleBirthDate || "");
const [responsibleEmail, setResponsibleEmail] = useState(bookingDataTmp?.bookingVoucherInfo?.responsibleEmail || "");
const [responsiblePhone, setResponsiblePhone] = useState(bookingDataTmp?.bookingVoucherInfo?.responsiblePhone || ""); 
const [responsibleIsGuest, setResponsibleIsGuest] = useState(bookingDataTmp?.bookingPaymentResponsible?.isHost == "0" ? false : true);
const [responsibleManualEdit, setResponsibleManualEdit] = useState(false);
const [responsibleDataFetched, setResponsibleDataFetched] = useState({});
const [responsibleFetching, setResponsibleFetching] = useState(false);  

// Set and keep booking data state
const [bookingData, setBookingData] = useState(bookingDataTmp || {});

// Guests
const [hostsArray, setHostsArray] = useState([]); // Array to store hosts and children for forms
const [panelVisibility, setPanelVisibility] = useState({});
const [hostDocumentType, setHostDocumentType] = useState({});
const [hostNoCpf, setHostNoCpf] = useState({});
const [hostDocument, setHostDocument] = useState({});
const [hostName, setHostName] = useState({});
const [hostBirthdate, setHostBirthdate] = useState({});
const [hostDataFetched, setHostDataFetched] = useState({});
const [hostManualEdit, setHostManualEdit] = useState({});
const [hostFetching, setHostFetching] = useState({});  

// console.log('[hostDataFetched]--------->]'+JSON.stringify(hostDataFetched, null, 2));

// Room
const [roomAdditionalInfo, setRoomAdditionalInfo] = useState("");
const maxChars = 150;
const isLimitReached = roomAdditionalInfo.length === maxChars;

const [roomExtraInfo, setRoomExtraInfo] = useState("");
const [roomCancelPolicy, setRoomCancelPolicy] = useState("");

// Action buttons
const [loadingQuote, setLoadingQuote] = useState(false);
const [loadingSendEmail, setLoadingSendEmail] = useState(false);
const [loadingNewBooking, setLoadingNewBooking] = useState(false);

// Collected Fees
const [collectedFeeDetails, setCollectedFeeDetails] = React.useState([]);
const [nonUsdFees, setNonUsdFees] = React.useState([]);

// Terms and Conditions
const [acceptTerm, setAcceptTerm] = React.useState(false);
const [termsModal, setTermsModal] = React.useState(false); 


const handleAdditionalInfoChange = (e) => {
    const value = e.target.value;
    if (value.length <= maxChars) {
        setRoomAdditionalInfo(value);
    }
};


const togglePanel = (index) => {
    setPanelVisibility((prev) => ({
        ...prev,
        [index]: !prev[index],
    }));
};

const handleHostDocumentTypeChange = (index, value) => {
    
    // Desliga o campo de "Sem CPF" se "Sou estrangeiro" for selecionado
    if (hostNoCpf[index]) {
        setHostNoCpf((prev) => ({
            ...prev,
            [index]: false,
        }));
    }

    setHostDocumentType((prev) => ({
        ...prev,
        [index]: value,
    }));

    setHostDocument((prev) => ({
        ...prev,
        [index]: "",
    }));
    setHostName((prev) => ({
        ...prev,
        [index]: "",
    }));
    setHostBirthdate((prev) => ({
        ...prev,
        [index]: "",
    }));
    

    if (value) {
        setHostManualEdit((prev) => ({
        ...prev,
        [index]: true,
    }));
    } else {
        setHostManualEdit((prev) => ({
        ...prev,
        [index]: false,
    }));
    }

};

const handleHostNoCpfChange = (index, value) => {
    
    // Desliga o campo de tipo de documento se "Sem CPF" for selecionado
    if (hostDocumentType[index]) {
        setHostDocumentType((prev) => ({
            ...prev,
            [index]: false,
        }));
    }

    setHostNoCpf((prev) => ({
        ...prev,
        [index]: value,
    }));

    setHostDocument((prev) => ({
        ...prev,
        [index]: "",
    }));
    setHostName((prev) => ({
        ...prev,
        [index]: "",
    }));
    setHostBirthdate((prev) => ({
        ...prev,
        [index]: "",
    }));
    

    if (value) {
        setHostManualEdit((prev) => ({
        ...prev,
        [index]: true,
    }));
    } else {
        setHostManualEdit((prev) => ({
        ...prev,
        [index]: false,
    }));
    }


};  

const handleHostDocumentChange = (index, value) => {
    setHostDocument((prev) => ({
        ...prev,
        [index]: value,
    }));
};  

const handleHostNameChange = (index, value) => {
    setHostName((prev) => ({
        ...prev,
        [index]: value,
    }));
};

const handleHostBirthdateChange = (index, value) => {
    setHostBirthdate((prev) => ({
        ...prev,
        [index]: value,
    }));
};  


const handleResponsibleDocumentType = (value) => {

    setResponsibleDocumentType(value);

    setResponsibleDocument("");
    setResponsibleName("");
    setResponsibleBirthDate("");
    setResponsibleEmail("");
    setResponsiblePhone("");    

    if (value) {
        setResponsibleManualEdit(true);
    } else {
        setResponsibleManualEdit(false);
    }

}  // end function


const handleTermsChange = (e) => {
    if (e.checked)
        setAcceptTerm(true);
    else
        setAcceptTerm(false);
}  // end function


const calcularIdade = (data,targetDate=null) => {
  if (!data) return '';

  // Tenta primeiro no formato DD/MM/YYYY
  let birth = moment(data, 'DD/MM/YYYY', true);

  // Se não for válido, tenta como data raw (pode ser ISO, timestamp, etc.)
  if (!birth.isValid()) {
    birth = moment(data);
  }

  if (!birth.isValid()) return '';

  // Return age     
  if (targetDate) {
    return moment(targetDate).diff(birth, 'years');
  } else {
    return moment().diff(birth, 'years');
  }

};

function calcularTotalTaxas(taxes) {

 if (!Array.isArray(taxes) || taxes.length === 0) {
    return 0; // Retorna 0 se não houver taxas
  }

  // Filtra apenas as taxas com relation = "included"
  const taxasIncluidas = taxes.filter(taxa => taxa.relation === "included");

  // Soma os valores do campo amount
  const total = taxasIncluidas.reduce((soma, taxa) => soma + taxa.amount, 0);

  return total;
}

function calcularTotalFees(taxes) {

 if (!Array.isArray(taxes) || taxes.length === 0) {
    return 0; // Retorna 0 se não houver taxas
  }

  // Filtra apenas as taxas com relation = "display"
  const taxasDisplay = taxes.filter(taxa => taxa.relation === "display");

  // Soma os valores do campo amount
  const total = taxasDisplay.reduce((soma, taxa) => soma + taxa.amount, 0);

  return total;
}

// useRef 
const toast = React.useRef(null);


// DEBUG
/*console.log('[rooms]----------> '+JSON.stringify(rooms,null,2));
console.log('availableChildren ----------------> '+JSON.stringify(availableChildren,null,2));
console.log('availableAdults ----------------> '+JSON.stringify(availableAdults,null,2));
console.log('[remainingAdults]----------> '+JSON.stringify(remainingAdults,null,2));
console.log('[remainingChildren]----------> '+JSON.stringify(remainingChildren,null,2));
console.log('[selectedGuests]----------> '+JSON.stringify(selectedGuests,null,2));
console.log('[selectedChildAges]----------> '+JSON.stringify(selectedChildAges,null,2));*/

// console.log('[searchFilters]----------------------> '+JSON.stringify(searchFilters,null,2));
//console.log('[resultCard]----------> '+JSON.stringify(resultCard,null,2)); 
// console.log('[resultsRooms]----------> '+JSON.stringify(resultsRooms,null,2)); 

// useEffect

/*
console.log('[selectedProperty]--------->]'+JSON.stringify(selectedProperty, null, 2));
console.log('[localCollectedFeeItems]--------->]'+JSON.stringify(localCollectedFeeItems, null, 2));
console.log('[totalAmount]--------->]'+JSON.stringify(totalAmount, null, 2));
console.log('[totalAmountPaidNow]--------->]'+JSON.stringify(totalAmountPaidNow, null, 2));
console.log('[totalAmountPaidNow]--------->]'+JSON.stringify(totalAmountPaidNow, null, 2));
console.log('[totalAmountPaidNow]--------->]'+JSON.stringify(totalAmountPaidNow, null, 2));


console.log('[responsibleDocumentType]--------->]'+JSON.stringify(responsibleDocumentType, null, 2));
console.log('[responsibleDocument]--------->]'+JSON.stringify(responsibleDocument, null, 2));
console.log('[responsibleName]--------->]'+JSON.stringify(responsibleName, null, 2));
console.log('[responsibleBirthDate]--------->]'+JSON.stringify(responsibleBirthDate, null, 2));
console.log('[responsibleEmail]--------->]'+JSON.stringify(responsibleEmail, null, 2));
console.log('[responsiblePhone]--------->]'+JSON.stringify(responsiblePhone, null, 2));
console.log('[responsibleIsGuest]--------->]'+JSON.stringify(responsibleIsGuest, null, 2));
console.log('[responsibleDataFetched]--------->]'+JSON.stringify(responsibleDataFetched, null, 2));

console.log('[hostsArray]--------->]'+JSON.stringify(hostsArray, null, 2));
console.log('[hostDocumentType]--------->]'+JSON.stringify(hostDocumentType, null, 2));
console.log('[hostNoCpf]--------->]'+JSON.stringify(hostNoCpf, null, 2));
console.log('[hostDocument]--------->]'+JSON.stringify(hostDocument, null, 2));
console.log('[hostName]--------->]'+JSON.stringify(hostName, null, 2));
console.log('[hostBirthdate]--------->]'+JSON.stringify(hostBirthdate, null, 2));
console.log('[hostDataFetched]--------->]'+JSON.stringify(hostDataFetched, null, 2));
*/


/* Activate Success Toast  */
const showSuccess = (title="",message="") => {
    toast.current.show({severity:'success', summary: title, detail:message, life: 6000});
}


// Configurar feriados nacionais e municipais do Rio de Janeiro
moment.updateLocale('pt-br', {
    holidays: config.BUSINESS_RULES.holidays, 
    holidayFormat: 'YYYY-MM-DD'
});

/* REDIRECT TO PAYMENT STEP IF PAYMENT IS CONFIRMED */ 
React.useEffect(() => {

    if (paymentConfirmed) {
        console.log('[PAYMENT CONFIRMED]--------->]');
        navigate("/order/hotel/booking/payment");
    } else {
        console.log('[PAYMENT NOT CONFIRMED]--------->]');
    }

}, [navigate]);


React.useEffect(() => {
    if (!hostsAndRooms) {
        setHostsAndRooms(null);
    }	
}, [hostsAndRooms]);

React.useEffect(() => {
    if (dateRange && dateRange[0] && dateRange[1]) {
        const diffTime = Math.abs(dateRange[1] - dateRange[0]);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        const formattedRange = formatDateRange(dateRange);
        let nightLabel = diffDays == 1 ? "noite" : "noites";
        setFormattedValue(`${formattedRange} (${diffDays} ${nightLabel})`);
    } else {
        setFormattedValue('');
    }
}, [dateRange]);

React.useEffect(() => {

    if (!currentBooking.property) {
        console.log('[CURRENT BOOKING DOES NOT EXIST - GO TO ORDER]--------->]');
        //navigate("/order");
    } // if
    else {
        toast.current.show({
            severity: 'success',
            summary: 'Sucesso!',
            detail: 'Reserva finalizada com sucesso.',
            life: 5000
        });  
    }

}, [currentBooking]);

const formatDateRange = (range) => {
    if (range && range[0] && range[1]) {
        const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
        return `${range[0].toLocaleDateString('pt-BR', options)} - ${range[1].toLocaleDateString('pt-BR', options)}`;
    }
    return '';
};
  
 
// Set calendar locale
addLocale('br', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
    dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
    dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
    monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
    today: 'Hoje',
    clear: 'Limpar'
});


// set Use of history for PUSH 
var navigate = useNavigate();

// Reload Controls, breadcrumb and map elements
const loadInterfaceElements = (searchFiltersArray=null) => {

      // Set date range and rooms
      setDateRange(searchFiltersArray ? searchFiltersArray.dateRange : searchParams.dateRange);
      setDateRangeDays(searchFiltersArray ? searchFiltersArray.dateRangeDays : searchParams.dateRangeDays);
      setRooms(searchFiltersArray ? searchFiltersArray.rooms : searchParams.rooms);	

}

// Runs when opens component
React.useEffect(() => {

    // Retrieve User Data Obj. 
    var result = localStorage.getItem("@dream4/userData", undefined,true);
    var userData = JSON.parse(result);  

      // If token dont exist, redirect to onboarding or register
      if (!userData) {
        console.log('[REDIRECIONOU PRA HOME. KOSSOMAK]--------->]');
        //  navigate("/home");
        //  return;
      } // end if
      
  // set scroll to top
  window.scrollTo(0, 1);

  // Simulate loading off
  setTimeout(() => {
    setContentLoading(false);
  }, 1000);

  // reset loading
  setCreatingBooking(false);

// Set USD exchange Rate and currency initials
if (searchParams?.country?.code == "BR") {
    const result = exchangeRates.find(item => item.targetCurrencyInitials === "USD");
    const exchangeRateValue = result.value;
    setUsdExchangeRate(exchangeRateValue); 
    setExchangeRateInitial("BRL"); 
}  

  // Load Interface elements
  loadInterfaceElements(); 

  // Delete current search if suceeed.
  executeDeleteDirectSearchResult();
    
  // Runs when UNMOUNT component
  return () => {

    setContentLoading(true); 
    setContentLoaded(false); 
    setHostingOptions(false); 
    setCurrentStep(1); 

    setCurrentContinent({}); 
    setCurrentCountry({}); 
    setCurrentCity({}); 
    setBreadcrumbArray([]); 

    setCurrentPlaces([]); 		
    setHostsAndRooms(null); 
    setRooms([{ adults: 2, children: [] }]); 
        
    setDateRange(null); 
    setFormattedValue('');
        
    setFilterByCity(null); 
    setFilterByCountry(null); 	

    setImageWithError(0);

    setCreatingBooking(false);
    
  };
  
}, []); // end useEffect 


React.useEffect(() => {
    // Calcula a soma total antes de atualizar o estado
    const total = selectedProperty.room.reduce((sum, item) => sum + (item.updatedPriceWithMarkup ? item.updatedPriceWithMarkup : item.totalWithMarkup), 0);

    // Set total amount paid now
    setTotalAmountPaidNow(total);

    const feesByCurrency = {};

    selectedProperty.room.forEach(item => {
        let fees = [];

        // Caso array direto
        if (Array.isArray(item.localCollectedFee)) {
            fees = item.localCollectedFee;
        }
        // Caso objeto com fees
        else if (item.localCollectedFee && Array.isArray(item.localCollectedFee.fees)) {
            fees = item.localCollectedFee.fees;
        }

        fees.forEach(fee => {
            if (fee.relation === "display" || fee.relation === undefined) {
                const feeCurrency = fee.currency;
                if (!feesByCurrency[feeCurrency]) {
                    feesByCurrency[feeCurrency] = 0;
                }
                feesByCurrency[feeCurrency] += fee.total || 0;
            }
        });
    });

    const usdFee = feesByCurrency["USD"] || 0;
    let grandTotal = total + usdFee;
    setTotalAmount(grandTotal);

    // Fees não-USD para Total
    const nonUsd = Object.entries(feesByCurrency)
        .filter(([currency]) => currency !== "USD")
        .map(([currency, total]) => ({ currency, total }));
    setNonUsdFees(nonUsd);

    // Para "Pagar na propriedade"
    const feeCurrencies = Object.keys(feesByCurrency);

    let payAtPropertyDetails = [];
    if (feeCurrencies.length === 1) {
        const singleCurrency = feeCurrencies[0];
        payAtPropertyDetails = [{
            currency: singleCurrency,
            total: feesByCurrency[singleCurrency],
        }];
    } else {
        payAtPropertyDetails = Object.entries(feesByCurrency).map(([currency, total]) => ({
            currency,
            total
        }));
    }

    setCollectedFeeDetails(payAtPropertyDetails);

    // Prepara array de hosts para forms
    let hostsArray = [];
    let currentIndex = 0;
    const room = selectedProperty?.hostsAndRoomsArray || [];
    const hostsAdults = room?.adults || 0;
    const childrenArr = Array.isArray(room?.children) ? room.children : [];
    const hostsChildren = childrenArr.length;

    for (let i = 0; i < hostsAdults; i++) {
        hostsArray.push({ type: 'adult', index: currentIndex });
        currentIndex++;
    }
    for (let i = 0; i < hostsChildren; i++) {
        hostsArray.push({ type: 'child', age: childrenArr[i].age || 0, index: currentIndex });
        currentIndex++;
    }
    setHostsArray(hostsArray);

    // Set label agrupado
    if (nonUsd.length > 0) {
        const formattedNonUsd = nonUsd.map(fee => `${formatNumberCurrency(fee.total, fee.currency)}`).join(" + ");
        setTotalAmountGrouped(`${formatNumberCurrency(totalAmountPaidNow, exchangeRateInitials)} + ${formattedNonUsd}`);
    } else {
        setTotalAmountGrouped(formatNumberCurrency(totalAmountPaidNow, exchangeRateInitials));
    }

    // Set labels
    selectedProperty.room.map((item, index) => {
        const valueAdds = item.valueAdds ? item.valueAdds?.["value-add"] : item?.["value-adds"]?.["value-add"];

        const hasCode = (code) => {
            if (!valueAdds) return false;
            if (Array.isArray(valueAdds)) {
                return valueAdds.some((valueAdd) => valueAdd.code === code);
            }
            return valueAdds.code === code;
        };

        if (selectedProperty.origin == "hyperguest") {
            const daysBefore = item.cancellationPolicies?.[0]?.daysBefore || 0;
            const cancellationDeadline = moment(dateRange[0]).businessSubtract(daysBefore, 'days').format('YYYY-MM-DD')
            item['cancellation-deadline'] = cancellationDeadline;
        }

        const hasFreeCancellation = item['cancellation-deadline'] ? item['cancellation-deadline'] : false;
        const hasFreeBreakfast = hasCode("free_breakfast");

        setRoomExtraInfo(hasFreeBreakfast ? "Café da manhã incluído" : "Nenhuma opção extra");
        setRoomCancelPolicy(hasFreeCancellation ? `Cancelamento Gratuito até ${moment(item['cancellation-deadline']).businessSubtract(2, 'days').format('DD/MM/YYYY')}` : "Nenhuma opção de cancelamento");

        const rawFee = item?.localCollectedFee?.fees || item?.localCollectedFee;
        const localCollectedFee = Array.isArray(rawFee) ? rawFee.filter(f => f?.relation === 'display' || f?.relation === undefined) : rawFee;
        setLocalCollectedFeeItems(localCollectedFee || []);
    });

}, [selectedProperty]);


/* confirm booking prompt START  */
const accept = (e) => {
    proceedToBookingPayment();
};

const reject = (e) => {
    //op.current.toggle(e);
};

const confirm = (event) => {
    confirmDialog({
        target: event.currentTarget,
        header: 'Confirmação de Pagamento',
        message: <div style={{maxWidth:"30rem"}}>Tem certeza que deseja iniciar o pagamento dessa reserva? <br /><br />Lembre-se que você tem que ter em mãos o cartão de crédito do responsável pelo pagamento da reserva. <br /><br /> A reserva deve ser paga até <strong>{moment(selectedProperty?.bookingData?.bookingInfo?.cancellationDeadline).format('DD/MM/YYYY')}</strong>, caso contrário, a reserva será cancelada.</div>,
        icon: 'pi pi-exclamation-triangle',
        accept,
        reject,
        dismissableMask:true,
        blockScroll:false,
        rejectLabel:"Não, farei isso depois.",
        acceptLabel:"Sim, vou prosseguir!"
    });
};
/* confirm booking prompt END  */

/* Function to fetch host data by document */
const fetchHostData = async (index) => {

    try {
        let documentValue = "";
        let isResponsible = false;

        // Detectar se é para responsável ou host
        if (index === "responsibleDocument") {
            documentValue = responsibleDocument.replace(/\D/g, '');
            isResponsible = true;
        } else {
            documentValue = hostDocument[index].replace(/\D/g, '');
        }

        // Validar se CPF foi preenchido e é válido
        if (!documentValue || documentValue.length !== 11 || !validarCPF(documentValue)) {
            toast.current.show({
                severity: 'warn',
                summary: "Atenção",
                detail: "CPF inválido ou incompleto. Verifique e ajuste antes de buscar.",
                life: 5000
            });
            return;
        }

        // Turn on loading state
        if (isResponsible) {
            setResponsibleFetching(true);
        } else {
            setHostFetching((prev) => ({ ...prev, [index]: true }));
        }

        // Chama action para buscar dados
        const result = await retrievePersonInfoByDocument({ personDocument: documentValue });

        // Turn off loading state
        if (isResponsible) {
            setResponsibleFetching(false);
        } else {
            setHostFetching((prev) => ({ ...prev, [index]: false }));
        }        

        if (result.success) {

            const name = result.personData.nome || '';
            const birthdate = result.personData.nascimento || '';

            const formattedBirth = birthdate ? birthdate.split("-").reverse().join("/") : "";

            if (isResponsible) {
                setResponsibleName(name);
                setResponsibleBirthDate(formattedBirth);
                setResponsibleDataFetched(result.personData);
            } else {
                setHostName((prev) => ({ ...prev, [index]: name }));
                setHostBirthdate((prev) => ({ ...prev, [index]: formattedBirth }));
                setHostDataFetched((prev) => ({ ...prev, [index]: result.personData }));
            }

            // Check if all data returned. If not, release manual edition.
            if (isResponsible) {
                if (!name || !formattedBirth) {
                    setResponsibleManualEdit(true);
                }
            } else {
                if (!name || !formattedBirth) {
                    setHostManualEdit((prev) => ({ ...prev, [index]: true }));
                }
            }
            
        } else {

            toast.current.show({
                severity: 'warn',
                summary: "Erro",
                detail: result.errorMessage || "Erro ao buscar dados do CPF. Tente novamente e caso não retorne, preencha o nome e data de nascimento manualmente.",
                life: 10000
            });

            // Check if all data returned. If not, release manual edition.
            if (isResponsible) {                
                setResponsibleManualEdit(true);
            } else {
                setHostManualEdit((prev) => ({ ...prev, [index]: true }));
            }

        }
    } catch (error) {

        // Turn off loading state
        if (index === "responsibleDocument") {
            setResponsibleFetching(false);
            setResponsibleManualEdit(true);
        } else {
            setHostFetching((prev) => ({ ...prev, [index]: false }));
            setHostManualEdit((prev) => ({ ...prev, [index]: true }));
        }

        toast.current.show({
            severity: 'error',
            summary: "Erro",
            detail: error.message || "Erro ao buscar dados do CPF. Tente novamente e caso não retorne, preencha o nome e data de nascimento manualmente pois os campos foram liberados para edição.",
            life: 10000
        });

    }
};


// Function to proceed to booking confirmation
// This function will be called when the user clicks on the "Proceed to Booking" button
const proceedToBookingPayment = async () => {
   
    navigate("/order/hotel/booking/payment");

};

// HELPER Generate voucher info for PDF
const generateVoucherInfo = () => {
    
  const hotel = selectedProperty.property;
  const room = selectedProperty.room[0];
  const enriched = room.enrichedData || {};
  const contact = enriched.contact || {};

  const data = {
    hotel_name: hotel.hotel_name +" - "+ selectedProperty.property.country +", "+selectedProperty.property.city,
    booking_period: `${moment(selectedProperty.dateRange[0]).format("DD/MM/YYYY")} a ${moment(selectedProperty.dateRange[1]).format("DD/MM/YYYY")}`,
    booking_number: 'N/D',
    hotel_address: hotel.hotel_address + ", " + selectedProperty.property.city +", "+selectedProperty.property.country,
    hotel_contact: {
      tel: hotel.phone ? hotel.phone : (contact.phone || ''),
      email: hotel.email ? hotel.email : (contact.email || ''),
      site: hotel.website ? hotel.website : (contact.website || '')
    },
    hotel_checkin: hotel?.checkin || "15:00 (confirmar com o hotel)",
    hotel_checkout: hotel?.checkout || "12:00 (confirmar com o hotel)",
    hotel_min_age_checkout: hotel?.min_age_checkout || "18",
    cancellation_deadline: roomCancelPolicy || '',
    cancellation_policy: room['cancellation-policy'] || '',
    total_amount: totalAmount
    ? `${formatNumberCurrency(totalAmount, exchangeRateInitials)}${
        nonUsdFees.length > 0 
          ? nonUsdFees.map(fee => ` + ${formatNumberCurrency(fee.total, fee.currency)}`).join('')
          : ''
      }`
    : '',

    total_booking: totalAmountPaidNow 
    ? `${formatNumberCurrency(totalAmountPaidNow, exchangeRateInitials)}` 
    : '',

    total_local: collectedFeeDetails && collectedFeeDetails.length > 0
    ? collectedFeeDetails.map(fee => `${formatNumberCurrency(fee.total, fee.currency)}`).join(' + ')
    : "0",
    additional_fees: (localCollectedFeeItems && localCollectedFeeItems.length > 0)
      ? localCollectedFeeItems.map(item => ({
          name: item.name,
          value: `${formatNumberCurrency(item.total, item.currency || currencyCollectedFeeAmount)}`
        }))
      : [],
    room: {
      title: room.room.title,
      room_name: room.extraDetails?.name?.en || '',
      room_responsible_name: responsibleName || '',
      room_hosts_label: selectedProperty.hostsLabel,
      room_extra: roomExtraInfo || 'Nenhum extra incluído',
      room_additional_info: roomAdditionalInfo || ''
    }
  };

    return data;

}

// Handle download quote PDF
const handleDownloadQuote = async () => {

  setLoadingQuote(true);


  // dOWNLOAD STARTED
    toast.current.show({ severity: 'info', summary: 'Gerando cotação', detail: 'O PDF está sendo gerado, por favor aguarde...', life: 4000 });


  const hotel = selectedProperty.property;
  const room = selectedProperty.room[0];
  const enriched = room.enrichedData || {};
  const contact = enriched.contact || {};

  const data = {
    hotel_name: hotel.hotel_name +" - "+ selectedProperty.property.country +", "+selectedProperty.property.city,
    booking_period: `${moment(selectedProperty.dateRange[0]).format("DD/MM/YYYY")} a ${moment(selectedProperty.dateRange[1]).format("DD/MM/YYYY")}`,
    booking_number: 'N/D',
    hotel_address: hotel.hotel_address + ", " + selectedProperty.property.city +", "+selectedProperty.property.country,
    hotel_contact: {
      tel: hotel.phone ? hotel.phone : (contact.phone || ''),
      email: hotel.email ? hotel.email : (contact.email || ''),
      site: hotel.website ? hotel.website : (contact.website || '')
    },
    hotel_checkin: hotel?.checkin || "15:00 (confirmar com o hotel)",
    hotel_checkout: hotel?.checkout || "12:00 (confirmar com o hotel)",
    hotel_min_age_checkout: hotel?.min_age_checkout || "18",
    cancellation_deadline: roomCancelPolicy || '',
    cancellation_policy: room['cancellation-policy'] || '',
    total_amount: totalAmount
    ? `${formatNumberCurrency(totalAmount, exchangeRateInitials)}${
        nonUsdFees.length > 0 
          ? nonUsdFees.map(fee => ` + ${formatNumberCurrency(fee.total, fee.currency)}`).join('')
          : ''
      }`
    : '',

    total_booking: totalAmountPaidNow 
    ? `${formatNumberCurrency(totalAmountPaidNow, exchangeRateInitials)}` 
    : '',

    total_local: collectedFeeDetails && collectedFeeDetails.length > 0
    ? collectedFeeDetails.map(fee => `${formatNumberCurrency(fee.total, fee.currency)}`).join(' + ')
    : "0",
    additional_fees: (localCollectedFeeItems && localCollectedFeeItems.length > 0)
      ? localCollectedFeeItems.map(item => ({
          name: item.name,
          value: `${formatNumberCurrency(item.total, item.currency || currencyCollectedFeeAmount)}`
        }))
      : [],
    room: {
      title: room.room.title,
      room_name: room.extraDetails?.name?.en || '',
      room_responsible_name: bookingData?.bookingVoucherInfo?.room?.room_responsible_name || '',
      room_hosts_label: selectedProperty.hostsLabel,
      room_extra: bookingData?.bookingVoucherInfo?.room?.room_extra || 'Nenhum extra incluído',
      room_additional_info: bookingData?.bookingVoucherInfo?.room?.room_additional_info || '- Nenhuma informação adicional-'
    }
  };

  const result = await downloadQuotePdf(data,'receipt'); 

  setTimeout(() => {
    
    
    setLoadingQuote(false)

    if (result.success) {
        showSuccess("Download iniciado!", "O arquivo será baixado em instantes.");
    } else {
        toast.current.show({ severity: 'error', summary: 'Erro', detail: 'Falha ao gerar PDF.', life: 4000 });
    }

  }, 2000);


};

const handleNewBooking = () => {

    setLoadingNewBooking(true);

    // Destrou current selected property
   // setSelectedProperty(null);

    setTimeout(() => {
        setLoadingNewBooking(false);
        // Show success message
        showSuccess("Nova reserva", "Você será redirecionado para a página de pesquisa de hotéis.");
        navigate("/order");
    }, 1000);

};

const handleSendEmailQuote = async () => {

    setLoadingSendEmail(true);

// dOWNLOAD STARTED
    toast.current.show({ severity: 'info', summary: 'Enviando cotação', detail: 'O PDF está sendo enviado, por favor aguarde...', life: 4000 });    


    setTimeout(() => {
        setLoadingSendEmail(false);
        // Show success message
        showSuccess("Cotação enviada!", "Verifique com o destinatário se o e-mail foi recebido com sucesso.");
    }, 2000);
};

// Delete Search properties method
const executeDeleteDirectSearchResult = async () => {

	var data = {
		searchResultToken:searchResultToken
	}		
    const result = await deleteDirectSearchResult(data);

    if (result.success) {

        // Set current booking
        setCurrentBooking(selectedProperty);  

    } else if (result.notFound) {

      if (!currentBooking.property) {
        // Redireciona se quiser
        console.log('[DELETOU BOOKING]--------->]');
        //navigate("/order");
      } 

    }
}


console.log('[currentAgency]--------->]'+JSON.stringify(currentAgency, null, 2));
console.log('[selectedProperty]--------->]'+JSON.stringify(selectedProperty, null, 2));
console.log('[localCollectedFeeItems]--------->]'+JSON.stringify(localCollectedFeeItems, null, 2));
console.log('[totalAmount]--------->]'+JSON.stringify(totalAmount, null, 2));
console.log('[exchangeRateInitials]--------->]'+JSON.stringify(exchangeRateInitials, null, 2));
console.log('[nonUsdFees]--------->]'+JSON.stringify(nonUsdFees, null, 2));
console.log('[totalAmountPaidNow]--------->]'+JSON.stringify(totalAmountPaidNow, null, 2));
console.log('[collectedFeeDetails]--------->]'+JSON.stringify(collectedFeeDetails, null, 2));
console.log('[bookingData]--------->]'+JSON.stringify(bookingData, null, 2));

/*
selectedProperty
localCollectedFeeItems                                                            
totalAmount
exchangeRateInitials
nonUsdFees
totalAmountPaidNow
collectedFeeDetails
bookingData*/

  return (
    <>
        
        {(creatingBooking) &&
            <>
            <div className="wrapper" style={{backgroundColor:"#00000066",zIndex:"999999",position:"fixed",left:0,top:0,display:"flex",justifyContent:"center",alignItems:"center",width:"100%",height:"100vh"}}>
    
                    <div style={{backgroundColor:"#FFFFFF",display:"flex",justifyContent:"center",alignItems:"center",width:"50%",height:"45vh",borderRadius:"60px",padding:"30px"}}>
    
                        <div style={{flex:1,display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column",width:"30vw"}}>
                            <ProgressSpinner />
                            <div className="formTitle" style={{marginBottom:"15px",marginTop:"15px"}}>Efetivando a sua reserva...Aguarde! </div>
                            <div className="formSubTitle">Isso levará um breve momento...Aguarde até a conclusão!</div>		
                            <div className="formSubTitle" style={{fontWeight:"bold",display:"flex",alignItems:"center",gap:"0.5rem"}}> <i className="pi pi-exclamation-triangle" style={{fontSize:"2rem",color:"orange"}}></i> Não recarregue ou saia dessa página</div>		                            
                            <div className="formSubTitle">DREAM4: hotéis 4 estrelas que você pode sonhar...</div>		
    
                        </div>
    
                    </div>
    
            </div>
            </>
        }		

    
    <div id="navigationSection" style={{width:"100%",margin:"0",paddingTop:"0px",paddingBottom:"0px",position:"relative",borderRadius:0}} className={isTabletOrMobile ? "login__wrapper mobile" : "login__wrapper"} >

            <div style={{minHeight:"600px",height:"auto"}} className={isTabletOrMobile ? "login__wrapper_form_wrapper mobile" : "login__wrapper_form_wrapper"}> 		
                <div className={isTabletOrMobile ? "login__form_wrapper mobile" : "login__form_wrapper"} style={{alignItems:"flex-start"}}>
                            
                    <div style={{flex:1,minHeight:"594px",marginLeft:"auto",marginRight:"auto"}}>
                        
                    <div className="searchWrapper" style={{padding: "3rem",paddingTop:"1.8rem",display: "flex",flexDirection: "column",justifyContent: "center",alignItems: "flex-start",gap: "0.8rem",width: "100%"}}>

                        <div className="backAndsearchFields w100" style={{marginBottom:"1rem"}}>

                                <div className="searchWrapperInput" style={{flex:"1",width:"100%",marginTop:"20px"}}>

                                    <div container style={{width:"100%",maxWidth:"1440px",display:"flex",flexDirection:"row",justifyContent:"end",alignItems:"center",gap:"10px"}}>

                                        <div style={{flex:"1",textAlign:"left"}}>
                              
                                        </div>                                      
                                        
                                    </div>
                                    
                                    
                                </div>												  
                              
                        </div>
        
                     
                        <div id="titleBox" className="titleBox selectBoxTitleOld animateOld flex-row justify-center align-items-center w100" style={{marginBottom:"0px",color: "#1D2939",fontSize: "2rem",fontStyle: "normal",fontWeight: 700,lineHeight: "2.12938rem",fontFamily:"Poppins",flex:"1",gap:"10px",maxWidth:"1440px"}} >


                            {/* LOADING  */}
                            {(contentLoading) &&
                                <>
                                    <div style={{backgroundColor:"transparent", width:"100%",marginTop:"5px",marginBottom:"5px",display:"flex",alignItems:"center",justifyContent:"flex-start",flexDirection:"row"}}>
                                    
                                        <div style={{flex:1}}>
                                            <Skeleton width="70%" height="5vh" ></Skeleton>
                                        </div>
                                                                                            
                                    </div>
                                                                     
                                </>				
                            }   

                            {/* LOADING  */}
                            {(!contentLoading) &&
                            <>
                                <div style={{textAlign:"left",flex:1,marginBottom:"2.5rem"}}>


                                    <div className="resultsCard_details__left flex-column justify-center align-items-start" style={{gap:"1.5rem",flex:1}}>

                                        <div className="resultsCard_details__name" style={{color: "#1D2939",fontFamily: "Poppins",fontSize: "1.5rem",
                                        fontStyle: "normal",fontWeight: 700,lineHeight: "normal",textAlign:"left"}}>Reserva confirmada</div>

                                        <div className="resultsCard_details__name" style={{color:"#475467",fontFamily:"Poppins",fontSize:"1.125rem",fontStyle:"normal",fontWeight:400,lineHeight:"160.5%",letterSpacing:"0.1125rem"}}>A reserva foi confirmada e a propriedade já recebeu as informações. <br /> Confirme os dados abaixo, finalize o pagamento ou inicie uma outra reserva. <br /> O pagamento da reserva está pendente. <br /> A reserva deve ser paga até <strong>{moment(selectedProperty?.bookingData?.bookingInfo?.cancellationDeadline).format('DD/MM/YYYY')}</strong>, caso contrário, a reserva será automaticamente cancelada.</div>

                                    </div>


                                </div>
                            </>
                            }
                
                        </div>
        

                        <div className="navigationContentWrapper flex-row justify-center align-items-start" style={{maxWidth:"1440px",marginTop:"0",width:"100%",flex:1,gap:"1rem"}}>

                                    <div className="resultsWrapper flex-column justify-center align-items-center" style={{gap:"1rem",flex:1}}>

                                        {/* BOOKING SUMMARY START */}  
                                        <div className="resultsCard flex-row justify-center align-items-stretch w100" style={{gap:"1rem",padding:"2rem",borderRadius: "1.87rem",background: "#FFFFFF"}}>

                                            {/* LOADING  */}
                                            {(contentLoading) &&
                                                <>
                                                    <div className="w100 flex-row justify-center align-items-stretch" style={{gap:"40px",height:"50vh"}}>
                                                        <div style={{flex:1}}>
                                                            <Skeleton width="100%" height="20rem" ></Skeleton>
                                                            <br />
                                                            <Skeleton width="100%" height="4rem" ></Skeleton>
                                                            <br />
                                                            <Skeleton width="100%" height="4rem" ></Skeleton>                              
                                                        </div>                                              
                                                    </div>
                                                </>				
                                            }                                            

                                            {/* LOADING  */}
                                            {(!contentLoading) &&
                                            <>
                                                <div className="flex-column justify-center align-items-center" style={{gap:"2rem",flex:1}}>

                                                    <div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"center",alignItems:"center",position:"relative"}}>

                                                        <div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem"}}>
                                            
                                                            <div className="bookingDetails_title">Dados da reserva</div>

                                                            <div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"745px"}}>

                                                                {currentAgency.agencyName &&
                                                                <>
                                                                    <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                        <div className="bookingDetails_wrapper_item_label">Agência</div>
                                                                        <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                        <div className="bookingDetails_wrapper_item_value">{currentAgency.agencyName || "Não definido"}</div>
                                                                    </div>
                                                                </>
                                                                }

                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Código da reserva</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value"><Message severity="warn" text="Aguardando pagamento" /></div>
                                                                </div>


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Voucher da reserva</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value"><Message severity="warn" text="Aguardando Pagamento" /></div>
                                                                </div>


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Data de hospedagem</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty?.dateRange ? (moment(selectedProperty?.dateRange[0]).format("DD/MM/YYYY") + " a " +moment(selectedProperty?.dateRange[1]).format("DD/MM/YYYY")) : "carregando..."}</div>
                                                                </div>

                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Código Interno</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{`${moment().format("YYYY.MM.DD")}${String(selectedProperty?.bookingId ?? "").padStart(4, "0")}`}</div>
                                                                </div>                                                                

                                                            </div>

                                                        </div>

                                                    </div> 

                                                </div>

                                            </>
                                            }

                                        </div>
                                        {/* BOOKING SUMMARY END */}  


                                        {/* HOTEL DETAILS - START */}
                                        <div className="resultsCard flex-row justify-center align-items-stretch w100" style={{gap:"1rem",padding:"2rem",borderRadius: "1.87rem",background: "#FFFFFF"}}>

                                            {/* LOADING  */}
                                            {(contentLoading) &&
                                                <>
                                                    <div className="w100 flex-row justify-center align-items-stretch" style={{gap:"40px",height:"50vh"}}>
                                                        <div style={{flex:1}}>
                                                            <Skeleton width="100%" height="20rem" ></Skeleton>
                                                            <br />
                                                            <Skeleton width="100%" height="4rem" ></Skeleton>
                                                            <br />
                                                            <Skeleton width="100%" height="4rem" ></Skeleton>                              
                                                        </div>                                              
                                                    </div>
                                                </>				
                                            }                                            

                                            {/* LOADING  */}
                                            {(!contentLoading) &&
                                            <>
                                                <div className="flex-column justify-center align-items-center" style={{gap:"2rem",flex:1}}>

                                                    <div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"center",alignItems:"center",position:"relative"}}>

                                                        <div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem"}}>
                                            
                                                            <div className="bookingDetails_title">Resumo das seleções</div>

                                                            <div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem",maxWidth:"745px"}}>

                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Destino selecionado</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty?.property?.country ? (selectedProperty.property.country +","+selectedProperty.property.city) : "carregando..." }</div>
                                                                </div>


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Hotel selecionado</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty?.property?.hotel_name || "carregando..."}</div>
                                                                </div>


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Data de hospedagem</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty?.dateRange ? (moment(selectedProperty?.dateRange[0]).format("DD/MM/YYYY") + " a " +moment(selectedProperty?.dateRange[1]).format("DD/MM/YYYY")) : "carregando..."}</div>
                                                                </div>


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Número de diárias</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty.dateRangeDays || "carregando..."}</div>
                                                                </div>


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Número de hospedes</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty?.hostsLabel || "carregando..."}</div>
                                                                </div>


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem",marginTop:"2rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Quarto 1</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty?.room?.[0]?.room?.title || "carregando..."}</div>
                                                                </div>  


                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label">Hóspedes</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">{selectedProperty?.hostsLabel || "carregando..."}</div>
                                                                </div>


                                                                {selectedProperty.room.map((item, index) =>{

                                                                        const valueAdds = item.valueAdds ? item.valueAdds?.["value-add"] : item?.["value-adds"]?.["value-add"]; // Safe access
                                                                        
                                                                        const totalPricewithMarkup = item?.updatedPriceWithMarkup || item.totalWithMarkup;
                                                                        
                                                                        const rawFee = item?.localCollectedFee?.fees || item?.localCollectedFee;

                                                                        const localCollectedFee = Array.isArray(rawFee)
                                                                        ? rawFee.filter(f => f?.relation === 'display' || f?.relation === undefined)
                                                                        : rawFee;


                                                                        // Função para verificar se um código específico está presente
                                                                        const hasCode = (code) => {
                                                                            if (!valueAdds) return false;

                                                                            // Verifica se é um array
                                                                            if (Array.isArray(valueAdds)) {
                                                                            return valueAdds.some((valueAdd) => valueAdd.code === code);
                                                                            }

                                                                            // Caso seja um objeto único
                                                                            return valueAdds.code === code;
                                                                        };

                                                                    
                                                                        // Set Deadline if origin is hyperguest
                                                                        if (selectedProperty.origin == "hyperguest") {
                                                                            const daysBefore = item.cancellationPolicies?.[0]?.daysBefore || 0;
                                                                            const cancellationDeadline = moment(dateRange[0]).businessSubtract(daysBefore, 'days').format('YYYY-MM-DD')
                                                                            item['cancellation-deadline'] = cancellationDeadline;
                                                                        }
                                                                                                                    
                                                                        // const hasFreeCancellation = hasCode("free_cancellation");
                                                                        const hasFreeCancellation = item['cancellation-deadline'] ? item['cancellation-deadline'] : false;
                                                                        const hasFreeBreakfast = hasCode("free_breakfast");


                                                                        return(
                                                                        <>
                                                                            <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                                <div className="bookingDetails_wrapper_item_label">Extras</div>
                                                                                <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                                <div className="bookingDetails_wrapper_item_value">                                      {hasFreeBreakfast && <>Café da manhã incluído</> }
                                                                                     {!hasFreeBreakfast && <>Nenhuma opção extra</>}  
                                                                                  </div>
                                                                            </div>  


                                                                            <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                                <div className="bookingDetails_wrapper_item_label">Cancelamento</div>
                                                                                <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                                <div className="bookingDetails_wrapper_item_value">
                                                                                    
                                                                                    {hasFreeCancellation && <>Cancelamento Gratuito <label style={{color:"#878787"}}>até {moment(item['cancellation-deadline']).businessSubtract(2, 'days').format('DD/MM/YYYY')}</label></>}
                                                                                    {!hasFreeCancellation && <>Cancelamento não reembolsável</>}
                                                                                    
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                        );

                                                                })}

                                                                {localCollectedFeeItems?.length > 0 && (
                                                                <div className="bookingDetails_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                    <div className="bookingDetails_wrapper_item_label tAlignL">Tarifas cobradas no local</div>
                                                                    <div className="bookingDetails_wrapper_item_line flex-1"></div>
                                                                    <div className="bookingDetails_wrapper_item_value">

                                                                        {localCollectedFeeItems.map((item, index) => (
                                                                            <div key={index} className="bookingDetails_wrapper_item_value_item tAlignR">
                                                                                {item.name}: {formatNumberCurrency(item.total, item.currency || currencyCollectedFeeAmount)}
                                                                            </div>
                                                                        ))}
    
                                                                    </div>
                                                                </div>)
                                                                }

                                                            </div>


                                                            <div className="bookingTotals" style={{marginTop:"4rem",width:"80%",maxWidth:"745px"}}>


                                                                    {/* TOTALS */}
                                                                    <div className="filterOptions_priceFilter__wrapper flex-column justify-center align-items-center" style={{width:"100%", gap:"0.5rem"}}>

                                                                        <div className="filterOptions_priceFilter__options flex-column justify-center align-items-center" style={{padding:"0.5rem", gap:"0.5rem", width:"100%"}}>

                                                                            <div className="flex-column justify-center align-items-right w100">

                                                                                {/* Total da hospedagem */}
                                                                                <div className="bookingTotals_wrapper_item flex-row justify-between align-items-center w100" style={{gap:"1rem"}}>
                                                                                    <div className="bookingTotals_wrapper_item_label">Total da hospedagem</div>
                                                                                    <div className="bookingTotals_wrapper_item_line flex-1"></div>
                                                                                    <div className="bookingTotals_wrapper_item_value">
                                                                                        {formatNumberCurrency(totalAmount, exchangeRateInitials)}
                                                                                        {nonUsdFees.length > 0 && nonUsdFees.map((fee, idx) => (
                                                                                            <span key={idx}> + {formatNumberCurrency(fee.total, fee.currency)}</span>
                                                                                        ))}
                                                                                    </div>
                                                                                </div>

                                                                                {/* Inclui impostos e taxas */}
                                                                                <div className="resultsCard_details__prices___dailyPrice w100" style={{color: "#878787", fontFamily: "Titillium Web", fontSize: "0.85rem", fontWeight: 400, lineHeight: "1.625rem", letterSpacing: "0.02875rem", textAlign:"right"}}>
                                                                                    inclui impostos e taxas
                                                                                </div>

                                                                                {/* Pagar na reserva */}
                                                                                <div className="resultsCard_details__prices___dailyPrice w100" style={{color:"#878787", fontFamily: "Poppins", fontSize: "1rem", fontWeight: 400, lineHeight: "2.12938rem", textAlign:"right", marginTop:"1rem"}}>
                                                                                    <span style={{fontSize:"0.85rem"}}>Pagar na reserva </span>
                                                                                    {formatNumberCurrency(totalAmountPaidNow, exchangeRateInitials)}
                                                                                </div>

                                                                                {/* Pagar na propriedade */}
                                                                                {collectedFeeDetails.length > 0 && (
                                                                                    <div className="resultsCard_details__prices___dailyPrice w100" style={{color:"#878787", fontFamily: "Poppins", fontSize: "1rem", fontWeight: 400, lineHeight: "2.12938rem", textAlign:"right", marginTop:"1rem"}}>
                                                                                        <span style={{fontSize:"0.85rem"}}>Pagar na propriedade </span>
                                                                                        {collectedFeeDetails.map((fee, idx) => (
                                                                                            <span key={idx}>{idx > 0 ? " + " : ""}{formatNumberCurrency(fee.total, fee.currency)}</span>
                                                                                        ))}
                                                                                        <div className="resultsCard_details__prices___dailyPrice w100" style={{color: "rgb(183 183 183)", lineHeight:"1rem", fontFamily: "Titillium Web", fontSize: "0.75rem", fontWeight:600, textAlign:"right"}}>
                                                                                            Os impostos e/ou taxas a serem pagos na propriedade serão pagos sempre na moeda local.
                                                                                        </div>
                                                                                    </div>
                                                                                )}

                                                                            </div>   

                                                                        </div>

                                                                    </div>
                                                                    {/* TOTALS END */}


                                                            </div>

                                                        </div>

                                                    </div> 

                                                </div>

                                            </>
                                            }

                                        </div>
                                        {/* HOTEL DETAILS - END */}  

                                        {/* HOTEL ADDITIONAL INFO - START */}
                                        <div className="resultsCard flex-row justify-center align-items-stretch w100" style={{gap:"1rem",padding:"2rem",borderRadius: "1.87rem",background: "#FFFFFF"}}>

                                            {/* LOADING  */}
                                            {(contentLoading) &&
                                                <>
                                                    <div className="w100 flex-row justify-center align-items-stretch" style={{gap:"40px",height:"50vh"}}>
                                                        <div style={{flex:1}}>
                                                            <Skeleton width="100%" height="20rem" ></Skeleton>
                                                            <br />
                                                            <Skeleton width="100%" height="4rem" ></Skeleton>
                                                            <br />
                                                            <Skeleton width="100%" height="4rem" ></Skeleton>                              
                                                        </div>                                              
                                                    </div>
                                                </>				
                                            }                                            

                                            {/* LOADING  */}
                                            {(!contentLoading) &&
                                            <>
                                                <div className="flex-column justify-center align-items-center" style={{gap:"2rem",flex:1}}>

                                                    <div className="resultsCard_image" style={{width:"100%",overflow:"hidden",display:"flex",justifyContent:"start",alignItems:"center",position:"relative"}}>

                                                        <div className="bookingDetails flex-column justify-start align-items-start w100" style={{gap:"0.5rem",padding:"1rem",maxWidth:"745px"}}>
                                            
                                                            <div className="bookingDetails_title">Quarto: {selectedProperty.room?.[0]?.room?.title || "carregando..."}</div>

                                                            <div className="bookingDetails_subtitle">Solicitação especial</div>

                                                            <div className="bookingDetails_description">Veja os detalhes da sua solicitação especial. Importante: a sua solicitação não está garantida e, se você não receber nenhuma resposta, entre em contato diretamente com a propriedade para confirmar.</div>

                                                            <div className="bookingDetails_wrapper flex-column justify-center align-items-start" style={{gap:"1rem"}}>

                                                                <div className="card flex justify-content-center w100 tAlignL">
                                                                    <span className="p-float-label w100">
                                                                        {bookingData?.bookingVoucherInfo?.room?.room_additional_info || "Nenhuma solicitação especial foi feita."}
                                                                    </span>
                                                                </div>                                                              
                                                                
                                                            </div>

                                                        </div>

                                                    </div> 

                                                </div>

                                            </>
                                            }

                                        </div>


                                        {/* HOTEL DETAILS - END */}                                                                 

                                    </div>
                                    
                                    {/* RIGHT COLUMN WITH CART DETAILS*/}
                                    <div className="filterWrapper flex-column justify-center align-items-start" style={{width:"25rem",height:"auto",gap:"1.5rem"/*,position:"sticky",top:"90px"*/}}>

                                            
                                        {/* Resumo da reserva */}
                                        <div className="filterOptions flex-column justify-center align-items-center" style={{width:"100%",height:"auto",borderRadius:"1rem",backgroundColor:"#FFFFFF",padding:"1rem",gap:"2rem"}}>

                                            <div className="filterOptions_title w100" style={{color:"#1D2939",fontFamily: "Poppins",fontSize: "1.5rem",fontStyle: "normal",fontWeight: 500,lineHeight: "2.12938rem",textAlign:"left",marginTop:"0.5rem"}}>Resumo da reserva</div>

                                            {/* LOADING  */}
                                            {(contentLoading) &&
                                                <>
                                                    <div style={{backgroundColor:"transparent", width:"100%",marginTop:"5px",marginBottom:"5px",display:"flex",alignItems:"center",justifyContent:"flex-start",flexDirection:"row"}}>
                                                    
                                                        <div style={{flex:1}}>
                                                            <Skeleton width="100%" height="5vh" ></Skeleton><br />
                                                            <Skeleton width="100%" height="5vh" ></Skeleton><br />
                                                            <Skeleton width="100%" height="5vh" ></Skeleton><br />
                                                            <Skeleton width="100%" height="5vh" ></Skeleton><br />      
                                                            <Skeleton width="100%" height="5vh" ></Skeleton>
                                                            
                                                        </div>
                                                                                                            
                                                    </div>
                                                                                    
                                                </>				
                                            }   	

                                            {/* LOADED  */}
                                            {(!contentLoading) &&
                                            <>
                                                <div className="filterOptions_priceFilter flex-column justify-center align-items-center w100" style={{gap:"0.5rem"}}>

                                                    <div className="filterOptions_priceFilter__wrapper flex-column justify-center align-items-center" style={{width:"100%",gap:"0.5rem"}}>
                                                    
                                                        <div className="filterOptions_priceFilter__options flex-column justify-center align-items-center" style={{gap:"1rem",width:"100%"}}>

                                                            <div className="flex-row justify-center align-items-center w100" style={{gap:"0.5rem",paddingBottom:"1rem",borderBottom:"1px solid #F8F8F8"}}>
                                                                <div style={{flex:1,textAlign:"left",color: "#475467",fontFamily: "Poppins",fontSize: "1.125rem",fontStyle: "normal",fontWeight: 400,lineHeight: "1.625rem",letterSpacing: "0.02875rem"}}>Período</div>
                                                                <div style={{flex:1.5,flexWrap:"nowrap",textAlign:"right",color: "#475467",fontFamily: "Poppins",fontSize: "0.875rem",fontStyle: "normal",fontWeight: 400,lineHeight: "160.5%",letterSpacing: "0.0875rem"}}>
                                                                    <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                        <span>De:</span>
                                                                        <span>{dateRange.length > 0 ? moment(dateRange[0]).format("DD/MM/YY (ddd)") : '-'}</span>
                                                                    </div>
                                                                    <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                        <span>Até:</span>
                                                                        <span>{dateRange.length > 0 ? moment(dateRange[1]).format("DD/MM/YY (ddd)") : '-'}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                                                                                    
                                                            <div className="flex-row justify-center align-items-center w100" style={{gap:"0.5rem",paddingBottom:"1rem",borderBottom:"1px solid #F8F8F8"}}>
                                                                <div style={{flex:1,textAlign:"left",color: "#475467",fontFamily: "Poppins",fontSize: "1.125rem",fontStyle: "normal",fontWeight: 400,lineHeight: "1.625rem",letterSpacing: "0.02875rem"}}>Diárias</div>
                                                                <div style={{flex:1.5,color: "#475467",textAlign: "right",fontSize: "0.9375rem",fontStyle: "normal",lineHeight: "1.625rem",letterSpacing: "0.02875rem"}}>{selectedProperty?.dateRangeDays || "carregando..."} noites</div>
                                                            </div>
                                                            
                                                            <div className="flex-row justify-center align-items-center w100" style={{gap:"0.5rem",paddingBottom:"1rem",borderBottom:"1px solid #F8F8F8"}}>
                                                                <div style={{flex:1,textAlign:"left",color: "#475467",fontFamily: "Poppins",fontSize: "1.125rem",fontStyle: "normal",fontWeight: 400,lineHeight: "1.625rem",letterSpacing: "0.02875rem"}}>Hospedes</div>
                                                                <div style={{flex:1.5,flexWrap:"nowrap",textAlign:"right",color: "#475467",fontFamily: "Poppins",fontSize: "0.875rem",fontStyle: "normal",fontWeight: 400,lineHeight: "160.5%",letterSpacing: "0.0875rem"}}>{selectedProperty?.hostsLabel || "carregando..."}</div>
                                                            </div>

                                                            <div className="flex-row justify-center align-items-center w100" style={{gap:"0.5rem",paddingBottom:"1rem",borderBottom:"1px solid #F8F8F8"}}>
                                                                <div style={{flex:1,textAlign:"left",color: "#475467",fontFamily: "Poppins",fontSize: "1.125rem",fontStyle: "normal",fontWeight: 400,lineHeight: "1.625rem",letterSpacing: "0.02875rem"}}>Quartos</div>
                                                                <div style={{flex:1.5,flexWrap:"nowrap",textAlign:"right",color: "#475467",fontFamily: "Poppins",fontSize: "0.875rem",fontStyle: "normal",fontWeight: 400,lineHeight: "160.5%",letterSpacing: "0.0875rem"}}>{selectedProperty?.roomsLabel || "carregando..."}</div>
                                                            </div>
                                                        

                                                        </div>
                                                    
                                                    </div>

                                                </div>

                                                {selectedProperty.room && selectedProperty.room.length > 0 &&
                                                <>
                                                {/* TOTALS */}
                                                <div className="filterOptions_priceFilter__wrapper flex-column justify-center align-items-center" style={{width:"100%", gap:"0.5rem"}}>

                                                    <div className="filterOptions_priceFilter__options flex-column justify-center align-items-center" style={{padding:"0.5rem", gap:"0.5rem", width:"100%"}}>

                                                    <div className="flex-column justify-center align-items-right w100">

                                                        {/* Total */}
                                                        <div className="resultsCard_details__prices___dailyPrice w100" style={{
                                                        color: " #00A3FF",
                                                        fontFamily: "Poppins",
                                                        fontSize: "1.5rem",
                                                        fontStyle: "normal",
                                                        fontWeight: 600,
                                                        lineHeight: "2.12938rem",
                                                        textAlign: "right"
                                                        }}>
                                                        <span style={{fontSize: "0.9375rem"}}>Total </span>
                                                        {formatNumberCurrency(totalAmount, exchangeRateInitials)}
                                                        {nonUsdFees.length > 0 && nonUsdFees.map((fee, idx) => (
                                                            <span key={idx}> + {formatNumberCurrency(fee.total, fee.currency)}</span>
                                                        ))}
                                                        </div>

                                                        <div className="resultsCard_details__prices___dailyPrice w100" style={{
                                                        color: "#878787",
                                                        fontFamily: "Titillium Web",
                                                        fontSize: "0.85rem",
                                                        fontStyle: "normal",
                                                        fontWeight: 400,
                                                        lineHeight: "1.625rem",
                                                        letterSpacing: "0.02875rem",
                                                        textAlign: "right"
                                                        }}>
                                                        inclui impostos e taxas
                                                        </div>

                                                        {/* Pagar na reserva */}
                                                        <div className="resultsCard_details__prices___dailyPrice w100" style={{
                                                        color: "#878787",
                                                        fontFamily: "Poppins",
                                                        fontSize: "1rem",
                                                        fontStyle: "normal",
                                                        fontWeight: 400,
                                                        lineHeight: "2.12938rem",
                                                        textAlign: "right",
                                                        marginTop: "1rem"
                                                        }}>
                                                        <span style={{fontSize:"0.85rem"}}>Pagar nessa reserva </span>
                                                        {formatNumberCurrency(totalAmountPaidNow, exchangeRateInitials)}
                                                        </div>

                                                        {/* Pagar na propriedade */}
                                                        {collectedFeeDetails.length > 0 && (
                                                        <div className="resultsCard_details__prices___dailyPrice w100" style={{
                                                            color: "#878787",
                                                            fontFamily: "Poppins",
                                                            fontSize: "1rem",
                                                            fontStyle: "normal",
                                                            fontWeight: 400,
                                                            lineHeight: "2.12938rem",
                                                            textAlign: "right",
                                                            marginTop: "1rem"
                                                        }}>
                                                            <span style={{fontSize:"0.85rem"}}>Pagar na propriedade </span>
                                                            {collectedFeeDetails.map((fee, idx) => (
                                                            <span key={idx}>{idx > 0 ? " + " : ""}{formatNumberCurrency(fee.total, fee.currency)}</span>
                                                            ))}
                                                            <div className="resultsCard_details__prices___dailyPrice w100" style={{
                                                            color: "rgb(183 183 183)",
                                                            lineHeight: "1rem",
                                                            fontFamily: "Titillium Web",
                                                            fontSize: "0.75rem",
                                                            fontStyle: "normal",
                                                            fontWeight: 600,
                                                            letterSpacing: "0.02875rem",
                                                            textAlign: "right"
                                                            }}>
                                                            Os impostos e/ou taxas a serem pagos na propriedade deverão ser pagos na moeda acima.
                                                            </div>
                                                        </div>
                                                        )}

                                                        {(!currentAgency.agencyCode && responsibleIsGuest) && 
                                                        <>
                                                            <div style={{marginTop:"1rem"}}>
                                                            <ConfirmDialog className="paymentConfirm" />
                                                            <Button
                                                                label="Iniciar pagamento"
                                                                rounded
                                                                className="pT10 mR10 headerButton tColorWhite w100"
                                                                onClick={(e) => {confirm(e)}} 
                                                            />
                                                            </div>
                                                        </>
                                                        }

                                                        {currentAgency.agencyCode && 
                                                        <>
                                                            <div className="flex-row justify-content-start align-items-center w100" style={{gap:"1rem",marginTop:"1rem",padding:"0.5rem"}}>
                                                                <img src={iconResponsibleWarning} alt="Aviso de Responsável" style={{width:"2.5rem",height:"auto"}} />
                                                                <div className="responsibleWarning">O pagamento dessa reserva só poderá ser feito pela agência proprietária da mesma. A agência recebeu uma notificação dessa reserva via email.</div>
                                                            </div>
                                                        </>
                                                        }    

                                                        {(!responsibleIsGuest && !currentAgency.agencyCode) && 
                                                        <>
                                                            <div className="flex-row justify-content-start align-items-center w100" style={{gap:"1rem",marginTop:"1rem",padding:"0.5rem"}}>
                                                                <img src={iconResponsibleWarning} alt="Aviso de Responsável" style={{width:"2.5rem",height:"auto"}} />
                                                                <div className="responsibleWarning">Como o responsável pelo pagamento não é um dos hóspedes, para realizar o pagamento você deve entrar em contato com o suporte.</div>
                                                            </div>
                                                        </>
                                                        }                                                                                                                

                                                    </div>

                                                    </div>

                                                </div>
                                                </>
                                                }


                                            </>
                                            }

                                        </div>


                                        {/* BOX Baixar PDF da cotação */}
                                        <div className="filterOptions flex-row justify-center align-items-center applyPointer" style={{width:"100%",height:"5rem",borderRadius:"1rem",backgroundColor:"#FFFFFF",padding:"1rem",gap:"1rem"}} onClick={handleDownloadQuote}>

                                            <div className="quotationButtonLabel w100 tAlignL" > {loadingQuote ? "Baixando..." : "Baixar PDF da confirmação"}</div>
    
                                            <div>
                                                <Button 
                                                icon={<><img src={iconDownload} alt="Baixar PDF" /></>}
                                                style={{width:"3rem",height:"auto",background:"none",border:0}}
                                            /></div>

                                        </div>

                                        {/* BOX Iniciar outra reserva */}
                                        <div className="filterOptions flex-row justify-center align-items-center applyPointer" style={{width:"100%",height:"5rem",borderRadius:"1rem",backgroundColor:"#FFFFFF",padding:"1rem",gap:"1rem"}} onClick={handleNewBooking}>

                                            <div className="quotationButtonLabel w100 tAlignL" > {loadingNewBooking ? "Iniciando..." : "Iniciar outra reserva"}</div>

                                            <div>
                                                <Button 
                                                icon={<><img src={iconNewBooking} alt="Iniciar outra reserva" /></>}
                                                style={{width:"3rem",height:"auto",background:"none",border:0}}
                                            /></div>

                                        </div>



                                    </div>

                        </div>


                    </div>				
                    
                    </div>

                </div> 
            </div>

    </div>	

        <Toast ref={toast} position="bottom-center" />

        <AlertView
            alert={alert}
            setAlert={setAlert}
            alertTitle={alertTitle}
            alertBody={alertBody}	
            scrollBlock={false}				
        />


        {/* Contac Us Section */}
        <ContactUs />

        {/* About Us Section */}
        <AboutUs />
    
    </>
  );
    
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  masterUser:store.appReducer.masterUser,
  currentAgency:store.appReducer.currentAgency,

  searchType:store.orderReducer.searchType,
  searchParams:store.orderReducer.searchParams,
  searchResultStatus:store.orderReducer.searchResultStatus,
  searchResultRowsNumber:store.orderReducer.searchResultRowsNumber,
  searchResultToken:store.orderReducer.searchResultToken,
  searchResultCurrentPage:store.orderReducer.searchResultCurrentPage,
  searchResultLimit:store.orderReducer.searchResultLimit,
  searchLocation:store.orderReducer.searchLocation,
  searchResultObj:store.orderReducer.searchResultObj,
  searchCurrency:store.orderReducer.searchCurrency,
  exchangeRates:store.orderReducer.exchangeRates,
  selectedProperty:store.orderReducer.selectedProperty,
  currentBooking:store.orderReducer.currentBooking,
  paymentConfirmed:store.orderReducer.paymentConfirmed
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions,...OrderActions }, dispatch);

export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(BookingConfirmation);	


